'use client';

import React, { useMemo } from 'react';
import { PageType, useGTM } from '@/features/Analytics';
import { DoctorPhones } from '@/features/Phones';
import { useDoctor } from '../../model/store';
import type { IMedcenter } from '@/entities/medcenter/model/types';
interface Props {
  medcenters?: IMedcenter[];
  hasPhones: boolean;
  doctorId?: number;
  doctorName: string;
}
export const BookingPhones: React.FC<Props> = ({
  hasPhones,
  doctorId,
  medcenters,
  doctorName
}) => {
  const {
    medcenterId
  } = useDoctor();
  const {
    trackEvent
  } = useGTM(PageType.DOCTOR_PROFILE);
  const currentMedcenter = useMemo(() => {
    if (medcenterId && medcenters) {
      return medcenters.find(medcenter => medcenter.id === medcenterId) || null;
    }
    return medcenters?.length ? medcenters[0] : null;
  }, [medcenters, medcenterId]);
  const handlePhoneCall = (phoneNumber: {
    type: string;
    phone: string;
  }) => {
    trackEvent('call_thedoctor', {
      numberType: phoneNumber.type,
      numberInfo: phoneNumber.phone
    });
  };
  const handleClosePhones = () => {
    trackEvent('close_phonenumber');
  };
  return <>
      {(hasPhones || currentMedcenter?.hasPhones) && <DoctorPhones doctorId={doctorId} medcenterId={medcenterId} title={currentMedcenter?.name || doctorName || ''} onPhoneCallGtmEvent={handlePhoneCall} onClosePhonesGtmEvent={handleClosePhones} />}
    </>;
};